export default function Modal({ children, shown, close }) {
    return shown ? (
      <div
        style={{
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 2,
          padding: "16px",
        }}
        className="modal-backdrop"
        onClick={() => {
          // close modal when outside of modal is clicked
          // close();
        }}
      >
        <div
          style={{
            width: "100%",
            height: "auto",
            maxHeight: "90vh",
            maxWidth: "450px",
            backgroundColor: "white",
            padding: "20px",
            fontSize: "14px",
            borderRadius: "15px",
            overflowY: "auto",
            WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS
          }}
          className="modal-content"
          onClick={(e) => {
            // do not close modal if anything inside modal content is clicked
            e.stopPropagation();
          }}
        >
          {children}

          {close && (
            <button
              style={{
                marginTop: "20px",
                padding: "12px 24px",
                border: "none",
                fontSize: "16px",
                fontWeight: "600",
                backgroundColor: "#d7458f",
                color: "white",
                borderRadius: "8px",
                width: "100%",
                cursor: "pointer",
              }}
              onClick={close}
            >
              Okay
            </button>
          )}
        </div>
      </div>
    ) : null;
  }